import React from 'react'

function ServicesComponent() {
  return (
    <div id='services'>
        <div className="section__header">
            <span className="section__eyebrow">&lt;Experience /&gt;</span>
            <h2 className="section__title">Current Job</h2>
        </div>
        <div className="service__box">
            <span className="icon"><img src="assets/02.png" alt="" /></span>
                <p>
                I am currently working at Mainbit as a web developer on internal projects using technologies such as Angular on the front end and Nest JS on the back end, SQL in the databases, and deployments on a Linux server and storage on AWS.
                </p>
                <a href="https://www.mainbit.com.mx/" className="see__more">See more
                   <i className="fi fi-br-arrow-small-right arrow"></i>
                </a>
        </div>
    </div>
  )
}

export default ServicesComponent